<template>
  <div ref="box" class="consent-box">
    <span @click="toggle" :class="`consent-box__checkbox ${value ? 'consent-box__checkbox--checked' : ''}`">
      <check-icon :checked="value" />
    </span>
    <div class="consent-box__text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'consent-box',
  props: {
    value: Boolean,
    shake: Boolean
  },
  data: () => ({
    shakeTimeout: null
  }),
  watch: {
    shake(val) {
      if (!val || this.shakeTimeout) {
        return
      }

      this.$refs.box.classList.add('consent-box--shake')
      this.shakeTimeout = setTimeout(() => {
        this.$refs.box.classList.remove('consent-box--shake')
        this.shakeTimeout = null
      }, 500)
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.consent-box {
  display: flex;
  align-items: center;
  padding: 0 10px 14px;
  border-radius: 12px;
  // background-color: rgba(207, 222, 230, 0.25);

  &--shake {
    animation: shake .5s;
  }

  & > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &__checkbox {
    position: relative;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: 7px;
    border: 2px solid #7C8F99;
    margin-right: 8px;
    transition: border-color 0.2s;
    cursor: pointer;

    & > .check-icon {
      position: absolute;
      top: -2px;
      left: 0;
      width: 22px;
      z-index: 0;
    }

    &--checked {
      border-color: #9A34FF;
    }
  }

  &__text {
    color: #7C8F99;
    text-align: left;
    font-weight: normal;

    & > a {
      font-weight: 900;
    }
  }
}

@keyframes shake {
  25% {
    margin-left: -6px;
    margin-right: 6px;
  }
  50% {
    margin-right: -6px;
    margin-left: 6px;
  }
  75% {
    margin-left: -6px;
    margin-right: 6px;
  }
  100% {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
